import {ApiServerTypeServicesAdd, ApiAddServer, ServerInterface, ServerRepositoryInterface, UpdateServer } from '@/services/Server/Interfaces';
import { AxiosInstance } from 'axios';

export enum ServerStatus {
  Up = 'Up',
  Down = 'Down',
}

export default class ServerRepository implements ServerRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async addServer(addServerDto: ApiAddServer): Promise<void> {
    await this.axios.post('/cloud-management/servers', addServerDto);
    return;
  }

  public async getAllServers(): Promise<ServerInterface[]> {
    const resp = await this.axios.get('/cloud-management/servers');

    return resp.data;
  }

  public async getServerTypes(): Promise<string[]> {
    const resp = await this.axios.get('/cloud-management/server-types');

    return resp.data;
  }

  public async getServerTypeServices(type: string): Promise<string[]> {
    const resp = await this.axios.get(`/cloud-management/server-types/${type}/services`);

    return resp.data;
  }

  public async getServersOfType(type: string): Promise<ServerInterface[]> {
    const resp = await this.axios.get(`/cloud-management/servers?type=${type}`);

    return resp.data;
  }

  public async addServerTypeServices(type: string, servicesDto: ApiServerTypeServicesAdd): Promise<string[]> {
    const resp = await this.axios.patch(`/cloud-management/server-types/${type}/services`,servicesDto);

    return resp.data;
  }


  public async getServersByIds(ids: string[]): Promise<ServerInterface[]> {
    if (!ids.length) {
      return [];
    }

    let url = `/cloud-management/servers?ids[]=`;
    url = `${url}${ids.join('&ids[]=')}`;

    const resp = await this.axios.get(url);

    return resp.data;
  }

  public async removeServer(serverId: string): Promise<void> {
    await this.axios.delete(`/cloud-management/servers/${serverId}`);
  }

  public async getServer(id: string): Promise<ServerInterface> {
    const resp = await this.axios.get(`/cloud-management/servers/view/${id}`);

    return resp.data;
  }

  public async updateServerStatus(hostname: string, status: string): Promise<void> {
    await this.axios.patch(`/cloud-management/servers/${hostname}/status`, { status })
  }

  public async updateServerById(id: string, data: UpdateServer): Promise<void> {
    await this.axios.patch(`/cloud-management/servers/${id}`, data)
  }
}
